import ReactModal from "react-modal";
import CloseIcon from "@/components/_icons/closeIcon";
import CryIcon from "@/components/_icons/cryIcon";
import { ConfirmButton } from "../button/confirmButton";
import { TextButton } from "../button/textButton";

export const DeliveryModalError = ({
  isOpen,
  onRequestClose,
  merchantColor,
  merchant,
  address,
  onEnterNewAddress,
  checkoutCloseHandler,
}: any) => {
  const switchToPickup = () => {
    const scheduledTimeString =
      global?.window?.localStorage.getItem("scheduledTime");
    const sessionTime = scheduledTimeString
      ? JSON.parse(scheduledTimeString)
      : {};
    const merchantService = merchant?.services.find(
      (s: any) => s.type === "PICKUP" || s.type === "WEBSITE"
    );
    const deliveryService = merchant?.services.find(
      (s: any) => s.type === "DELIVERY"
    );
    let enabledDefaultOrderType = "";
    const retailServices = [
      { type: "pickup", service: merchantService },
      { type: "delivery", service: deliveryService },
    ];
    const enabledServices = retailServices.filter(
      ({ service }) => service?.enabled
    );

    if (enabledServices.length >= 1) {
      enabledDefaultOrderType = enabledServices[0].type;
    }
    global?.window?.localStorage.setItem(
      "scheduledTime",
      JSON.stringify({
        orderType: merchant?.isRetail ? enabledDefaultOrderType : "pickup",
        date: sessionTime?.date || null,
        time: sessionTime?.time || null,
      })
    );
    if (merchant?.isRetail) {
      window.dispatchEvent(
        new StorageEvent("storage", { key: "pickup-order-type" })
      );
    }
    checkoutCloseHandler();
    onRequestClose && onRequestClose();
  };
  return (
    <ReactModal
      ariaHideApp={false}
      appElement={global?.window?.document?.getElementById("app") || undefined}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="fixed inset-0 flex items-center justify-center"
      overlayClassName="fixed inset-0 bg-black bg-opacity-50 z-50"
    >
      <div className="bg-white sm:rounded-lg shadow-lg w-[100%] h-[100%] sm:h-[auto] sm:w-[70%] mx-auto overflow-hidden">
        <div className="flex justify-between items-center px-6 pt-6">
          <button
            onClick={switchToPickup}
            className="text-gray-600 hover:text-gray-900 ml-auto"
          >
            <CloseIcon />
          </button>
        </div>
        <div className="px-4 pb-4 flex flex-col justify-center items-center">
          <CryIcon brandingColor={merchantColor} />
          <p className="mt-4 text-3xl font-medium text-center text-[#373737] text-[32px]">
            Deliveries cannot be made to your address
          </p>
          <p className="mt-4 text-base leading-6 text-center text-[15px] text-neutral-700 w-full">
            {merchant.name} cannot make deliveries to
          </p>
          <p className="text-base font-bold leading-6 text-center text-[15px] text-neutral-700 w-full">
            {address.address1}, {address.city}, {address.state}, {address.zip}
          </p>
          <p className="mt-4 text-base leading-6 text-center text-[15px] text-neutral-700 w-full">
            Choose a different address or place an order for pickup
          </p>
          <ConfirmButton
            onClick={switchToPickup}
            style={{ backgroundColor: merchantColor }}
            className="px-16 py-4 mt-24 max-w-full text-xl font-medium leading-7 text-center text-white whitespace-nowrap bg-[#228800] disabled:bg-[#C7C7C7] rounded-lg w-[250px] max-md:px-5 max-md:mt-10"
          >
            <p>Switch to pickup</p>
          </ConfirmButton>
          <TextButton
            onClick={onEnterNewAddress}
            style={{ color: merchantColor }}
          >
            <p>Enter new address</p>
          </TextButton>
        </div>
      </div>
    </ReactModal>
  );
};
